import { AttributeValue } from './attribute-value';

export class SelectOption {
    value: string;
    sortorder: number;
    attributeValues: AttributeValue[] = [];

    constructor(selectOption?: SelectOption) {
        if (selectOption != null) {
            this.value = selectOption.value;
            this.sortorder = selectOption.sortorder;

            if (selectOption.attributeValues != null) {
                for (const av of selectOption.attributeValues) {
                    this.attributeValues.push(new AttributeValue(av));
                }
            }
        }
    }
}